/**
 * 注册全局组件
 */
import BaseCard from "@/components/base-card";
import BaseCardType from "@/components/base-cardType";
import EchartsPie from "@/components/echarts-pie";
import baseEmpty from "@/components/base-empty";
import baseLoading from "@/components/base-loading";

const components = {
  install: function (Vue) {
    Vue.component("base-card", BaseCard);
    Vue.component("base-cardType", BaseCardType);
    Vue.component("echarts-pie", EchartsPie);
    Vue.component("base-empty", baseEmpty);
    Vue.component("base-loading", baseLoading);
  },
};

export default components;
